export default __webpack_public_path__ + "static/media/tg.7350e43f.svg";